import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { getDataFetchingClientRequestState } from '../../dataFetchingClient/utils/getDataFetchingClientRequestState';
export function useCollectionItems(query, fieldName, {
  appContext,
  collectionId,
  language,
  length,
  offset
}) {
  const {
    data,
    previousData,
    error,
    loading
  } = useQuery(query, {
    variables: {
      appContext,
      collectionId,
      language,
      length,
      offset
    }
  });
  const requestState = getDataFetchingClientRequestState(error, loading);
  const collectionItems = useMemo(() => {
    const collectionItemsData = data || previousData;
    return collectionItemsData ? collectionItemsData[fieldName] : undefined;
  }, [data, fieldName, previousData]);
  const collectionOfferingIds = useMemo(() => {
    if (!collectionItems) {
      return [];
    }

    return collectionItems.items.reduce((final, item) => {
      if ('offeringId' in item && typeof item.offeringId === 'number') {
        final.push(item.offeringId);
      }

      return final;
    }, []);
  }, [collectionItems]);
  return {
    data: collectionItems,
    offeringIds: collectionOfferingIds,
    requestState: requestState
  };
}